const productReviews = (appKey, productId, productType)=>({
  productReviewObject: null,
  productReviews: [],
  votedUp: false,
  votedDown: false,
  selectedImage: null,
  selectedImageHeight: 0,
  selectedImageWidth: 0,
  fetchUrl: '',
  fetchRatingUrl: '',
  totalReviews: '',
  productType: productType,
  async init(){
    this.fetchUrl = `https://api-cdn.yotpo.com/v3/storefront/store/${appKey}/reviews?page=1&perPage=10&sort=date,images,badge,rating`
    this.fetchRatingUrl = `https://api-cdn.yotpo.com/v3/storefront/store/${appKey}/product/${productId}/ratings`
    this.getProductReviews().then()
  },
  async getProductReviews(){
    await fetch(this.fetchUrl)
      .then(res=>res.json())
      .then(data => {
        this.productReviewObject = data

        if (data){
          this.products = data.products
          this.productReviews = data.reviews
          this.totalReviews = data.bottomline.totalReview;
          this.productReviews = this.productReviews.map(review => {
            return {...review, product: this.products.filter(product => product.id === review.product_id)[0]}
          })
        }
      }).then(async ()=>{
        const enrichedReviews = this.productReviews.map(review => {
          const product = this.products.find(p => p.id === review.product_id);
          return { ...review, product };
        });

        // Now detect image orientation for each review's product image
        this.productReviews = await Promise.all(
          enrichedReviews.map(review => {
            return new Promise(resolve => {
              const img = new Image();
              img.src = review.product.imageUrl;

              img.onload = () => {
                const orientation = img.naturalWidth > img.naturalHeight ? "landscape" : "portrait";
                resolve({
                  ...review,
                  product: {
                    ...review.product,
                    orientation,
                  },
                });
              };

              img.onerror = () => {
                // Fallback if image fails to load
                resolve({
                  ...review,
                  product: {
                    ...review.product,
                    orientation: "unknown",
                  },
                });
              };
            });
          })
        );
        console.log(this.productReviews)
      })
  },

  async getProductRating() {
    try {
      const response = await fetch(this.fetchRatingUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data.bottomline.totalReviews;

    } catch (error) {
      console.error('Error fetching product rating:', error);
      return '';
    }
  },
  voteUp(id){
    const options = {
      method: 'POST',
      headers: {accept: 'application/json', 'Content-Type': 'application/json'}
    };
    fetch(`https://api.yotpo.com/reviews/${id}/vote/up`, options)
      .then(res => res.json())
      .then(res => console.log(res))
      .catch(err => console.error(err));
  },
  undoVoteUp(id){
    const options = {
      method: 'POST',
      headers: {accept: 'application/json', 'Content-Type': 'application/json'}
    };
    fetch(`https://api.yotpo.com/reviews/${id}/vote/up/true`, options)
      .then(res => res.json())
      .then(res => console.log(res))
      .catch(err => console.error(err));
  },
  voteDown(id){
    fetch(`https://api.yotpo.com/reviews/${id}/vote/down`, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json'
      }
    }).then(res => res.json()).then(data => {
      if (data.status.code === 200){
        this.votedDown = true
        this.votedUp = false
      }
    })
  },
  undoVoteDown(id){
    fetch(`https://api.yotpo.com/reviews/${id}/vote/down/true`, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json'
      }
    }).then(res => res.json()).then(data => {
      if (data.status.code === 200){
        this.votedDown = true
        this.votedUp = false
      }
    })
  }
})

export default productReviews

window.addEventListener("alpine:init", ()=>{
  Alpine.data("productReviews", productReviews)
})

